import { connect } from 'react-redux';
import Reports from './Reports';

const mapStateToProps = (state: any) => ({
  activeOrganization: state.auth.activeOrganization
});

export default connect(mapStateToProps)(Reports);
